import React from 'react';

import handShakeIcon from 'images/partners/hand-shake.svg';

const PartnerHeader = () => {
  return (
    <div className="my-40 flex flex-col items-center px-16 sm:my-48 sm:flex-row sm:items-start sm:px-28">
      <img src={handShakeIcon} className="mb-8 py-6 sm:mb-0 sm:mr-32" role="presentation" />
      <div>
        <h1 className="m-0 text-center font-serif text-headline-xl text-primary-black sm:text-left">
          Partners
        </h1>
        <p className="body-lg mb-0 mt-16 max-w-full font-serif text-primary-black sm:mt-24 sm:text-[1.5rem] md:max-w-[78%]">
          We welcome working with companies to help them access our journalism and reach our
          subscribers with high-quality messages.
        </p>
      </div>
    </div>
  );
};

export default PartnerHeader;
